import { Model } from '@lernetz/ts-lib';

export class ScoreQuizResult extends Model {

    public minPoints: number;
}
